import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsScrollerUsersDepositsByCurrency = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/scrollers/deposits/by-currency`, {params});
};